import type { Catalog as CatalogsType } from "@repo/fetch-repository/catalogs";
import { Download } from "../../icons/download";

export function Catalog({
  catalog,
}: {
  catalog: CatalogsType;
}): React.JSX.Element {
  return (
    <div>
      <div className="flex items-start lg:flex-row flex-col mb-20">
        <div className="lg:mb-0 mb-4">
          <img
            alt={
              !Array.isArray(catalog.cover.data)
                ? catalog.cover.data.url || ""
                : ""
            }
            className="lg:h-64 h-38 lg:max-w-56 lg:min-w-56 max-w-28 min-w-28 rounded-md"
            onError={(e) => {
              e.currentTarget.src = "/images/placeholder.png";
            }}
            src={
              !Array.isArray(catalog.cover.data) ? catalog.cover.data.url : ""
            }
          />
        </div>
        <div className="lg:px-20">
          <div className="font-helvetica rtl:font-doran uppercase lg:mb-6 mb-2 lg:pb-3 lg:text-2xl text-lg text-primary font-[100] rtl:font-bold">
            {catalog.title}
          </div>
          <div
            className="font-helvetica rtl:font-doran text-base lg:text-xl leading-loose text-justify text-[#6a6e77] mb-6 max-h-[100px] overflow-hidden text-ellipsis"
            dangerouslySetInnerHTML={{ __html: catalog.description }}
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          />
          {!Array.isArray(catalog.file.data) ? (
            <div className="flex">
              <a
                className="mx-2"
                download
                href={catalog.file.data.url}
                rel="noopener"
                target="_blank"
              >
                <Download />
              </a>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
